import { render, staticRenderFns } from "./search-metrics.component.vue?vue&type=template&id=7ec1d8d0&scoped=true"
import script from "./search-metrics.component.vue?vue&type=script&lang=ts"
export * from "./search-metrics.component.vue?vue&type=script&lang=ts"
import style0 from "./search-metrics.component.vue?vue&type=style&index=0&id=7ec1d8d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec1d8d0",
  null
  
)

export default component.exports